import {Modal as BsModal, Button} from 'react-bootstrap';
import {useEffect, useState} from "react";


export const Modal = ({show, size = 'md', fullscreen = false, children, onSave, onShow, onClose, closeOnSave = true}) => {
    const [showModal, setShowModal] = useState(false)

    const handleClose = () => {
        setShowModal(false);
        if (typeof onClose !== "function") return;
        onClose();
    }


    const handleSave = () => {
        if (closeOnSave) {
            handleClose();
        }
        if (typeof onSave !== "function") return;
        onSave();
    }

    const handleOnShow = () => {
        if (typeof onShow !== "function") return;
        onShow();
    }

    useEffect(() => {
        setShowModal(show)
    }, [show]);


    return (<BsModal centered backdrop="static" size={size} show={showModal} onHide={handleClose} onShow={handleOnShow}>
        <BsModal.Header closeButton>

        </BsModal.Header>
        <BsModal.Body>{children}</BsModal.Body>
        <BsModal.Footer className="justify-content-center">
            <Button size="sm" variant="primary" onClick={handleSave}>
                Save Changes
            </Button>
        </BsModal.Footer>
    </BsModal>)
}